import { generalReducer } from './General/GeneralReducer';
import { combineReducers } from 'redux';

const MeterStore = combineReducers({
    generalReducer,
})
export default MeterStore